import { useDispatch, useSelector } from 'react-redux';
import HeaderSession from '../../utils/headerSession'
import RegisterAccess from '../../utils/registerAccess'
import ButtonSwitchSistem from './buttonSwitchSistem'
import { useEffect, useState } from 'react';
import api from '../../services/api';
import { Button, Divider, Typography } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import GestQuota from '../departamentos/dmts/importacaoExportacao/getQuota';
import VerifyPermission from '../../utils/verifyPermission';
import { temPermissao } from '../../utils/permissoes';
import { useNavigate } from 'react-router-dom';
import InfoFieldGroup from '../../utils/InfoField/InfoFieldGroup';


export default function Definicoes() {
    const user = useSelector(state => state.account.user);
    const [definicoesSistema, setDefinicoesSistema] = useState('')
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (temPermissao(user, ['definicoesSistema'])) {
        } else {
            dispatch({
                type: "alert",
                payload: { alert: "Acesso negado" },
            });
            navigate("/admin/menu");
        }

        api.get(`/definicoes/sistema/all`)
            .then(response => {
                setDefinicoesSistema(response.data.definicoesSistema[0]);
            }).catch(err => '')
    }, [])

    const Header = ({ header }) => { return (<Typography m={1}> <b>{header}</b> </Typography>) }
    return (
        <>
            <RegisterAccess page={''} />
            <HeaderSession title={'DEFINIÇÕES DE SISTEMA'} />

            <Header header={'SECÇÕES DO SITE'} />
            {/* <ButtonSwitchSistem
                url={'/definicoes/sistema/seccoes'}
                definicao={'servicos'}
                definicoes={definicoesSistema?.seccoes}
                setdefinicoes={setDefinicoesSistema}
                title={'Desabilitar/Habilitar servicos'}
                descricao={''}
            /> */}
            
            <InfoFieldGroup
                fields={
                    [
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/seccoes'}
                                    definicao={'agenda'}
                                    definicoes={definicoesSistema?.seccoes ?? definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar agenda'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/seccoes'}
                                    definicao={'noticias'}
                                    definicoes={definicoesSistema?.seccoes}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar noticias'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/seccoes'}
                                    definicao={'destaques'}
                                    definicoes={definicoesSistema?.seccoes}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar destaques'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/seccoes'}
                                    definicao={'reclamacao'}
                                    definicoes={definicoesSistema?.seccoes}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar reclamações'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/seccoes'}
                                    definicao={'links'}
                                    definicoes={definicoesSistema?.seccoes}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar links'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                    ]} />




            <Header header={'SECÇÃO DE SERVIÇOS'} />
            <InfoFieldGroup
                fields={
                    [
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'informacoes'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar informações'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'agenda'}
                                    // definicoes={definicoesSistema?.servicos}
                                    definicoes={definicoesSistema?.servicos ?? definicoesSistema?.seccoes}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar marcação de agenda'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'renovacaoAutorizacao'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar renovação de autorização'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'autorizados'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar autorizados'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'reclamacao'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar reclamação'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'estabelecimentosLicenciados'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar lista actualizada de estabelicementos licenciados'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'importacaoExportacao'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar importação e exportação'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'certificadoProdutosControlados'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar solicitação de certificado de produtos controlados'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'desalfandegamento'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar solicitação de desalfandegamento'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'analiseLaboratorial'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar solicitação de nalise laboratorial'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'farmacovigilancia'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar farmacovigilância'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'registosMedicamentos'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar registo de medicamentos'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                    ]} />


            <Header header={'OUTROS SERVIÇOS'} />
            <InfoFieldGroup
                fields={
                    [
                        {
                            // label: 'Dashboard',
                            value:
                                <ButtonSwitchSistem
                                    url={'/definicoes/sistema/servicos'}
                                    definicao={'solicitarNumeroDeImportador'}
                                    definicoes={definicoesSistema?.servicos}
                                    setdefinicoes={setDefinicoesSistema}
                                    title={'Desabilitar/Habilitar soliicitação de número de importador'}
                                    descricao={''}
                                />
                            , editable: false,
                        },
                    ]} />


            <Divider />

            <br />
            <Header header={'GESTÃO GEOGRÁFICA'} />
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', margin: '8px 4px 16px' }}>
                <Button
                    variant="outlined"
                    startIcon={<MapIcon />}
                    onClick={() => navigate('/admin/gestor-provincias')}
                    sx={{ borderColor: '#85287e', color: '#85287e', '&:hover': { borderColor: '#6a1f63', backgroundColor: '#f9f0f9' } }}
                >
                    Gestão de Províncias
                </Button>
                <Button
                    variant="outlined"
                    startIcon={<LocationCityIcon />}
                    onClick={() => navigate('/admin/gestor-municipios')}
                    sx={{ borderColor: '#85287e', color: '#85287e', '&:hover': { borderColor: '#6a1f63', backgroundColor: '#f9f0f9' } }}
                >
                    Gestão de Municípios
                </Button>
            </div>

            <Divider />

            <br />
            <VerifyPermission permissions={user?.permissions} permission={'gestQuota'}>
                <Header header={'OUTRAS DEFINIÇÕES'} />
                <GestQuota />
            </VerifyPermission>
        </>
    )
}
